import { Box, Button, TextField, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useContext } from 'react';
import { CampaignContext } from '../../contexts/CampaignContext';
import { ISmsPanelContent } from '../../interfaces/campaign';

type PreviewMediaGrowthProps = {
	smsContent: ISmsPanelContent | null;
	handleOpenPostModal: () => void;
	previewContent?: boolean;
};

const PreviewMediaGrowth: React.FC<PreviewMediaGrowthProps> = ({ smsContent, handleOpenPostModal }) => {
	const { t } = useTranslation();
	const { selectedMediaTypeId } = useContext(CampaignContext);
	const tableData = smsContent?.table;
	return (
		<>
			<Box className="relative flex gap-x-6 pt-10">
				<Box className={`flex w-full gap-5`}>
					{selectedMediaTypeId === 'popup' ? (
						<>
							<Button variant="text" className="absolute left-5 top-0 m-0 flex self-end px-0" onClick={handleOpenPostModal}>
								{t('edit')}
							</Button>

							<Box className="w-full">
								<TextField
									InputProps={{
										readOnly: true,
									}}
									fullWidth
									label={t('text_message')}
									variant="outlined"
									multiline
									rows={5}
									value={smsContent?.description}
								/>
								<div className="mt-5 flex flex-wrap justify-between">
									<TextField
										InputProps={{
											readOnly: true,
										}}
										size="medium"
										label={t('link')}
										fullWidth
										variant="outlined"
										value={smsContent?.link}
									/>
								</div>
								<div className="mt-4 flex justify-center bg-blue-50 p-5">
									<Box>
										<Typography className="mx-8 font-bold">{t('title')}</Typography>
										<Typography className="mx-8">{tableData?.title}</Typography>
									</Box>
									<Box>
										<Typography className="mx-8 font-bold">{t('price')}</Typography>
										<Typography className="mx-8">{tableData?.price} تومان</Typography>
									</Box>
									<Box>
										<Typography className="mx-8 font-bold">{t('followers')}</Typography>
										<Typography className="mx-8">{tableData?.followers}</Typography>
									</Box>
								</div>
							</Box>
						</>
					) : (
						<>
							<Button variant="text" className="absolute left-5 top-0 m-0 flex self-end px-0" onClick={handleOpenPostModal}>
								{t('edit')}
							</Button>

							<Box className="w-full">
								<TextField
									InputProps={{
										readOnly: true,
									}}
									fullWidth
									label={t('text_message')}
									variant="outlined"
									multiline
									rows={5}
									value={smsContent?.text}
								/>
								<div className="mt-5 flex flex-wrap justify-between gap-4">
									<TextField
										InputProps={{
											readOnly: true,
										}}
										size="medium"
										label={t('link')}
										className="w-[48%]"
										variant="outlined"
										value={smsContent?.link}
									/>
									<TextField
										InputProps={{
											readOnly: true,
										}}
										size="medium"
										label={t('price')}
										className="w-[48%]"
										variant="outlined"
										value={smsContent?.price}
									/>
									<TextField
										InputProps={{
											readOnly: true,
										}}
										size="medium"
										label={t('absorptionRate')}
										className="w-[48%]"
										variant="outlined"
										value={smsContent?.absorptionRate}
									/>
								</div>
							</Box>
						</>
					)}
				</Box>
			</Box>
		</>
	);
};

export default PreviewMediaGrowth;
